import { Component, Input } from '@angular/core';
import { SectionItem } from '@interface/sectionitem.interface';

@Component({
  selector: 'app-mealset-options',
  templateUrl: './mealset-options.component.html',
  styleUrls: ['./mealset-options.component.scss']
})

export class MealsetOptionsComponent {
  @Input() menuItems:SectionItem[] = [];
  @Input() costExtra: boolean = false;
  isArray(value:any) {
    return Array.isArray(value)
  }
}
